import {
  EcommerceAPIApi as EcommerceApi,
  type PublicSiteNavigation,
} from '@parkingbase/ecommerce-api-dev';

import { BaseApiService } from './baseApi.service';

/** Request timeout. The api serves this from its 60 s shared cache, so 8 s is a hung request. */
export const SITE_NAVIGATION_TIMEOUT_MS = 8000;

export class SiteNavigationService extends BaseApiService {
  protected siteNavigationApi: EcommerceApi;

  constructor() {
    super();
    this.siteNavigationApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  /**
   * Reads the published site navigation of this domain (`GET /site/navigation`).
   *
   * `skipAuth` is intentional: the endpoint is public and domain-resolved, like `GET /site/page`.
   *
   * ## Invariants:
   * - Failures (network error, timeout, non-2xx including a 404 from a pod that predates the
   *   endpoint) PROPAGATE. The store is the one place that logs them and falls back to today's
   *   header; swallowing here would turn a failure into a quiet DEFAULT.
   */
  async getSiteNavigation(): Promise<PublicSiteNavigation> {
    const response = await this.siteNavigationApi.getPublicSiteNavigation({
      skipAuth: true,
      timeout: SITE_NAVIGATION_TIMEOUT_MS,
    });
    return response.data;
  }
}
